import type { CollectionRow } from '@/types/api';

/**
 * Qué se puede hacer con un cobro desde la lista.
 *
 * Vive aparte del componente para poder fijar las reglas con tests: cuáles se ofrecen
 * es una decisión de negocio, no de maquetación. La regla general es **no ofrecer lo
 * que va a fallar** — un recordatorio a un cliente sin email es un clic que sólo puede
 * terminar en error.
 */
export type RowAction =
    | 'markPaid'
    | 'downloadPdf'
    | 'viewInvoice'
    | 'viewContact'
    | 'changePlan'
    | 'cancelService';

export function availableActions(row: CollectionRow): RowAction[] {
    const actions: RowAction[] = [];
    const isPaid = row.collectionStatus === 'PAID';

    // Marcar pagada no se ofrece dos veces: revertirlo no es limpio, porque
    // "marcar como enviada" cambia el estado pero deja la fecha de pago puesta,
    // y esta página considera pagado todo lo que la tenga.
    if (!isPaid) actions.push('markPaid');

    actions.push('downloadPdf', 'viewInvoice');

    if (row.contact?.id) actions.push('viewContact');

    // Gestión del servicio, no de esta nota. Sólo tiene sentido en un cobro que se
    // repite, y sólo si el backend manda el id: ofrecerlo sin él sería un clic que no
    // puede funcionar. Que la nota esté pagada no congela el plan del servicio.
    if (row.billingType !== 'ONE_OFF' && row.subscriptionId) {
        actions.push('changePlan', 'cancelService');
    }

    return actions;
}
